<template>
  <el-header>
    <el-link :underline="false"
             class="company"
             href="/">
      {{ $t('APP.COMPANY') }}
    </el-link>
    <div class="space"></div>
    <app-offline></app-offline>
    <app-connected-user></app-connected-user>
  </el-header>
</template>

<script>
import AppConnectedUser from '@/components/connected-user/ConnectedUser'
import AppOffline from '@/components/offline/Offline'

export default {
  name: 'AppHeader',
  components: { AppConnectedUser, AppOffline }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Freightforge';
  src: url('/fonts/FreightForge-Regular.ttf') format('truetype');
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: unset !important;

  padding: 1rem 1.5rem;

  border-bottom: 1px solid #DCDFE6;

  .company {
    font-family: Freightforge, Arial, sans-serif;
    font-size: 25px;
    color: #11589F;
    user-select: none;
  }

  .space {
    flex: 1;
  }

  .app-connected-user {
    margin-left: 1rem;
  }
}
</style>
